export default function headerHover (){
    $(".ulHover li").hover(
        function() {
            $(this).parents().eq(2).attr("href", $(this).attr("href"));
        }, 
        function(){
            $(this).css("color", "#ACACAC");
            $(this).parents().eq(2).attr("href", $(this).attr("hrefMain"));
        }
    );
}